import { render } from "./ConsumerOffers.vue?vue&type=template&id=675fce40&scoped=true"
import script from "./ConsumerOffers.vue?vue&type=script&lang=js"
export * from "./ConsumerOffers.vue?vue&type=script&lang=js"

import "./ConsumerOffers.vue?vue&type=style&index=0&id=675fce40&scoped=true&lang=css"
import "./ConsumerOffers.vue?vue&type=style&index=1&id=675fce40&lang=css"
script.render = render
script.__scopeId = "data-v-675fce40"

export default script